import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);

    // Load from localStorage on app start
    useEffect(() => {
        const savedToken = localStorage.getItem("jwt_token");
        const savedUser = localStorage.getItem("jwt_user");
        if (savedToken && savedUser) {
            setToken(savedToken);
            setUser(JSON.parse(savedUser));
        }
        setLoading(false);
    }, []);

    const login = (userData, jwtToken) => {
        setUser(userData);
        setToken(jwtToken);
        localStorage.setItem("jwt_token", jwtToken);
        localStorage.setItem("jwt_user", JSON.stringify(userData));
    };

    const logout = () => {
        setUser(null);
        setToken(null);
        localStorage.removeItem("jwt_token");
        localStorage.removeItem("jwt_user");
    };

    const isLoggedIn = !!token;

    return (
        <AuthContext.Provider
            value={{ user, token, isLoggedIn, login, logout, loading }}
        >
            {children}
        </AuthContext.Provider>
    );
}
